module.exports = __webpack_public_path__ + "static/why-certificate-4c0f15190ef0e6cc51c99c31594547c1.jpg";